var React = require('react');

function ChevronBackward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.1256 9.50805L0.360806 2.74367C0.131063 2.51365 0.0134258 2.22454 0.00788975 1.87633C0.00263023 1.52839 0.120269 1.23402 0.360806 0.993204C0.60162 0.752666 0.893365 0.632399 1.23604 0.632399C1.57872 0.632399 1.87046 0.752666 2.11127 0.993204L9.57526 8.45718C9.73054 8.61275 9.84015 8.77675 9.90409 8.94919C9.96803 9.12164 10 9.30792 10 9.50805C10 9.70817 9.96803 9.89445 9.90409 10.0669C9.84015 10.2393 9.73054 10.4033 9.57526 10.5589L2.11127 18.0229C1.88126 18.2526 1.59214 18.3703 1.24393 18.3758C0.895994 18.3811 0.60162 18.2634 0.360806 18.0229C0.120269 17.7821 0 17.4903 0 17.1477C0 16.805 0.120269 16.5132 0.360806 16.2724L7.1256 9.50805Z","fill":"white"}));
}

ChevronBackward.defaultProps = {"width":"10","height":"19","viewBox":"0 0 10 19","fill":"none"};

module.exports = ChevronBackward;

ChevronBackward.default = ChevronBackward;
